import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku';
import { useNotification } from './NotifPopup';
import { useConfirm } from './ModalConfirm';
import {sortData} from '../components/Fungsiku';
import {ExcelDown} from '../components/ExcelDown';
import {ExcelUp} from '../components/ExcelUp';

const REQ_GROUP_PAGE19_ANGGARAN_LOAD = 'page19-anggaran-load';
const REQ_GROUP_PAGE19_OPSI_LOAD = 'page19-opsi-load';
const REQ_GROUP_PAGE19_SUBMIT = 'page19-submit';

const PROPOSAL_STATUS_LABEL = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  APPR: 'APPROVED',
  TRANSFERED: 'TRANSFERRED',
};

const escapeExcelHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const sanitizeExcelFilePart = (value) =>
  String(value ?? '')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '_')
    .replace(/\s+/g, '_');

const buildProposalExcelHtml = ({ title, subtitle, rows }) => {
  const headers = ['No.', 'Akun', 'Sub Akun', 'Nominal Pengajuan', 'Nominal Approval'];
  const headerHtml = headers
    .map((header) => (
      `<th style="background:#0f2d5c;color:#ffffff;font-weight:400;text-align:center;">${escapeExcelHtml(header)}</th>`
    ))
    .join('');
  const bodyHtml = rows
    .map((row) => (
      `<tr>` +
        `<td style="text-align:right;">${escapeExcelHtml(row.nomor)}</td>` +
        `<td>${escapeExcelHtml(row.akun)}</td>` +
        `<td>${escapeExcelHtml(row.subakun)}</td>` +
        `<td style="text-align:right;">${escapeExcelHtml(row.nominalPengajuan)}</td>` +
        `<td style="text-align:right;">${escapeExcelHtml(row.nominalApproval)}</td>` +
      `</tr>`
    ))
    .join('');

  return `\uFEFF<html><head><meta charset="UTF-8"></head><body>` +
    `<table border="1">` +
      `<colgroup>` +
        `<col style="width:50px;">` +
        `<col style="width:180px;">` +
        `<col style="width:240px;">` +
        `<col style="width:150px;">` +
        `<col style="width:150px;">` +
      `</colgroup>` +
      `<thead>` +
        `<tr><th colspan="5" style="background:#0f2d5c;color:#ffffff;font-size:14pt;font-weight:700;text-align:center;">${escapeExcelHtml(title)}</th></tr>` +
        `<tr><th colspan="5" style="background:#dbeafe;color:#0f172a;font-weight:600;text-align:center;">${escapeExcelHtml(subtitle)}</th></tr>` +
        `<tr>${headerHtml}</tr>` +
      `</thead>` +
      `<tbody>${bodyHtml}</tbody>` +
    `</table>` +
  `</body></html>`;
};

//ANGGARAN PETTY CASH
export function PageKonten19({token, authIdentity = {}, globalOpsi}) {
  const opsiCabang = globalOpsi.opsiCabang;
  const kodeCabangUser = String(authIdentity?.kode_cabang || "").trim();
  const namaUser = String(authIdentity?.nama || "").trim();
  const isPusat = kodeCabangUser === 'C-1';
  const namaCabangUser = (
    isPusat
      ? 'Pusat'
      : (
        (Array.isArray(opsiCabang) ? opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === kodeCabangUser
        )?.nama_cabang || kodeCabangUser || '-'
      )
  );
  const { showNotif } = useNotification();
  const { showConfirm } = useConfirm();
  const [loading, setLoading] = useState(false);
  const [cabang, setCabang] = useState(isPusat ? '' : kodeCabangUser);
  const [status, setStatus]=useState('DRAFT'); //DRAFT , SENT , APPROVED , TRANSFERED
  const formatBulan = (value) => { // dari angka bulan 1 --> Januari
    return new Intl.DateTimeFormat("id-ID", {month: "long"}).format(new Date(tahun, value-1, 1))};
  const [bulan, setBulan] = useState('');
  const [opsiBulan, setOpsiBulan] = useState([]);
  const bulanNow = new Date().getMonth() + 1;  
  const tahunNow = new Date().getFullYear();
  const [tahun, setTahun] = useState(tahunNow);
  const [filter, setFilter] = useState('');
  const [search, setSearch] = useState('');
  const [totalPro, setTotalPro] = useState(0);
  const [totalApp, setTotalApp] = useState(0);
  const [isiAnggaran, setIsiAnggaran] = useState ([]);
  const opsiTahun = bulanNow === 12  
                      ? Array.from({ length: tahunNow + 1 - 2025 }, (_, i) => tahunNow + 1 - i ) 
                      : Array.from({ length: tahunNow - 2025 }, (_, i) => tahunNow - i );
  const formatWIB = (isoUTC) => { //string ISO jadi dirubah ke DD/MM/YYYY untuk ditampilkan di tabel
    if (!isoUTC) return "";
    const date = new Date(isoUTC);
    return date.toLocaleDateString("id-ID", {
        timeZone: "Asia/Jakarta"
    });
  };  
  const trimTxt = (txt) =>    (txt ?? "")
                              .toString()
                              .toLowerCase()
                              .replace(/[\r\n]+/g, "")
                              .trim();
  const [dataProses, setDataProses] = useState([]);
  const [dataAnggaran, setDataAnggaran] = useState([]);
  const [opsiSubAkun, setOpsiSubAkun] = useState([]);
  //const [filteredData, setFilteredData] = useState(null);
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value));
  };
  const filteredData = useMemo(() => {
  return isiAnggaran
    .filter(item =>
      trimTxt(item.akun).includes(trimTxt(filter))
    )
    .filter(item =>
      trimTxt(item.akun).includes(trimTxt(search)) ||
      trimTxt(item.subakun).includes(trimTxt(search))
    );
  }, [isiAnggaran, filter, search]);

  async function loadDataAnggaran(cabang, bulan, tahun) {
    if(!bulan) return;
    setLoading(true);
    console.log("load bulan = ", bulan);
    console.log("load tahun = ", tahun);
    console.log("cabang = ", cabang);
    const t0 = performance.now();
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_PAGE19_ANGGARAN_LOAD,
        reason: 'refresh petty anggaran page19',
      });
      const res = await api.get(
        `${backendPort}/api/main/petty_anggaran`,
        {
          params : {
            tahun,
            bulan,
            cabang,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
          requestGroup: REQ_GROUP_PAGE19_ANGGARAN_LOAD,
          timeout: 30000,
        }
      );
      console.log("Waktu total request:", (performance.now() - t0).toFixed(2), "ms");
      if(res?.data?.isi?.length > 0){
        console.log("res.data = ", res.data);
        setDataAnggaran(res.data);
        setStatus(res?.data?.st_angg ?? 'DRAFT');
      } else {
        console.log("res.data = kosong");
        setDataAnggaran([]);
        setIsiAnggaran([]);
        setStatus('DRAFT');
      }
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const loadOpsi = async (item) => {
    try {
      api.cancelPendingRequests({
        group: REQ_GROUP_PAGE19_OPSI_LOAD,
        reason: `refresh petty opsi ${item}`,
      });
      const res = await api.get(
        `${backendPort}/api/main/petty_opsi`,
        {
          params: {item},
          headers: {
            Authorization: `Bearer ${token}`,
          },
          requestGroup: REQ_GROUP_PAGE19_OPSI_LOAD,
          timeout: 120000,
        }
      );
      setOpsiSubAkun(res.data);
    } catch (err) {
      if (api.isCanceledError(err)) return;
      console.error(err);
    }
  }
  const uniqueAkun = useMemo(() => {
      return [...new Set(opsiSubAkun.map(x => x.akun))];
  }, [opsiSubAkun]);
  useEffect(() => {
    if (!isPusat) {
      setCabang(kodeCabangUser || '');
    }
  }, [isPusat, kodeCabangUser]);
  

  useEffect(()=>{
    const opsi = 
    tahun === tahunNow 
      ? Array.from({ length: bulanNow + 1 }, (_, i) => {return bulanNow + 1 - i} )
      : tahun === tahunNow+1 
        ? [1] 
        : [12, 11, 10, 9, 8, 7, 6, 5 , 4, 3, 2, 1];
    setOpsiBulan(opsi);
    console.log("opsi = ", opsi);
  },[tahun]);

  useEffect(() => {
    loadOpsi('subakun');
  }, []);

  useEffect(() => {
    setBulan('');
    setIsiAnggaran([]);
    setDataAnggaran([]);
  }, [cabang]);

  useEffect(() => {
    if(!cabang || !bulan || ! tahun){ 
      console.log(`batal loading karena data tidak lengkap: ${cabang}-${bulan}-${tahun}`);
      
      setDataAnggaran([]);
      setIsiAnggaran([]);
      return;
    };
    loadDataAnggaran(cabang, bulan, tahun);
    const data = sortData(opsiSubAkun,'akun');
    setDataProses(data);
  },[bulan, tahun]);
  
  useEffect(()=>{
    if(!dataAnggaran?.isi && !dataProses) {console.log(`data belum lengkap`); return;}
    
    const isi = dataAnggaran?.isi ?? [];
    const isiMap = {};

    isi.forEach(row => {
      const key = `${trimTxt(row.akun)}|${trimTxt(row.subakun)}`;
      isiMap[key] = row;
    });

    const data = dataProses.map(dprow => {
      const key = `${trimTxt(dprow.akun)}|${trimTxt(dprow.subakun)}`;
      const found = isiMap[key];

      return {
        ...dprow,
        nom_pro: found?.nom_pro ?? 0,
        nom_app: found?.nom_app ?? 0
      };
      });
     setIsiAnggaran(data);
     setStatus(dataAnggaran?.st_angg ?? 'DRAFT');   
  },[dataAnggaran]);
  {/**
  useEffect(()=>{
      const filterMatch = isiAnggaran.filter(item => trimTxt(item.akun??'').includes(trimTxt(filter)));
      const searchMatch = filterMatch.filter(item => trimTxt(item.akun??'').includes(trimTxt(search)) || trimTxt(item.subakun??'').includes(trimTxt(search)));     
      setFilteredData(searchMatch);
    },[isiAnggaran, filter, search]);
   */}
   
  useEffect(()=>{
    if(!isiAnggaran) return;
    const totalPro = isiAnggaran.reduce((sum, item) => {
      return sum + (Number(item.nom_pro) || 0);
    }, 0)
    const totalApp = isiAnggaran.reduce((sum, item) => {
      return sum + (Number(item.nom_app) || 0);
    }, 0)
    setTotalPro(totalPro);
    setTotalApp(totalApp);
    //console.log("isiAnggaran =", isiAnggaran);
  },[isiAnggaran]);

  async function handleSubmitProposal (newStatus, isiAngg = isiAnggaran ){
    setLoading(true);
    try{
        const isApp = isPusat;
        const data_status = {
          isApp,
          cabang,
          tahun   : Number(tahun),
          bulan   : Number (bulan),
          status  : newStatus,
          user    : namaUser,  
        };

        const data_isi = isiAngg
          .filter(x => x.nom_pro > 0 || x.nom_app > 0)
          .map(x => { const nomnom = isApp ? x.nom_app : x.nom_pro;
                      return {
                        akun : x.akun,
                        subakun : x.subakun,
                        nominal : nomnom,
                      }});
        
        console.log('kirim ke API=', data_status, data_isi);  
        
        api.cancelPendingRequests({
          group: REQ_GROUP_PAGE19_SUBMIT,
          reason: 'submit petty anggaran terbaru',
        });
        await api.post(`${backendPort}/api/main/petty_anggaran_appr`,
          {
            data_status,
            data_isi
          },
          {   
            headers: { Authorization: `Bearer ${token}` },
            requestGroup: REQ_GROUP_PAGE19_SUBMIT,
            timeout: 120000
          }
        );
        console.log("berhasil submit proposal");  

        setStatus(data_status.status);
        await showNotif('success', 'Kirim Data Berhasil');        
    
      } catch (err) {
      if (api.isCanceledError(err)) return;
      console.log(err);   
      showNotif('error', 'Kirim Data Gagal');
    } finally {
      setLoading(false);
    }
  };
  
  async function handleUpload(){
    const dataFile = await ExcelUp() ?? [];
    const fileMap = {};
    dataFile.forEach(row => {
        const key = `${trimTxt(row.kolom2)}|${trimTxt(row.kolom3)}`;
        fileMap[key] = row;
      });
    
    const data = dataProses.map(dprow => {
      const key = `${trimTxt(dprow.akun)}|${trimTxt(dprow.subakun)}`;
      return {
        ...dprow,
        nom_pro: fileMap[key]?.kolom4 ?? 0,
        nom_app: 0
      };
    });  
     setIsiAnggaran(data);
  }

  async function handlecopy(){
    if(!isPusat) return;
    const data = isiAnggaran.map(dprow => {return {
        ...dprow,
        'nom_app' : isiAnggaran.find(row => `${trimTxt(row.akun)}+${trimTxt(row.subakun)}` === `${trimTxt(dprow.akun)}+${trimTxt(dprow.subakun)}`)?.nom_pro ?? 0,
       }});
     //console.log("IsiAnggaran = ", data);  
     setIsiAnggaran(data);
  }

  function handleDownloadProposal() {
    if (!cabang || !bulan) {
      showNotif('error', 'Pilih cabang dan bulan anggaran terlebih dahulu');
      return;
    }
    if (
      !Array.isArray(isiAnggaran) ||
      isiAnggaran.length === 0 ||
      (isPusat && !(dataAnggaran?.isi?.length > 0))
    ) {
      showNotif('error', 'Tidak ada data proposal untuk di-download');
      return;
    }

    const namaCabang = (
      (Array.isArray(opsiCabang) ? opsiCabang : []).find(
        (item) => String(item?.kode_cabang || '').trim() === String(cabang || '').trim()
      )?.nama_cabang || namaCabangUser || cabang
    );
    const namaBulan = formatBulan(Number(bulan));
    const statusKey = String(status || '').toUpperCase();
    const statusLabel = PROPOSAL_STATUS_LABEL[statusKey] || statusKey || '-';
    const statusDateSource = statusKey === 'SENT'
      ? dataAnggaran?.tgl_pro
      : (statusKey === 'APPR' || statusKey === 'TRANSFERED' || statusKey === 'TRANSFERRED')
        ? dataAnggaran?.tgl_app
        : null;
    const statusDate = statusDateSource
      ? new Date(statusDateSource).toLocaleDateString('id-ID', {
          timeZone: 'Asia/Jakarta',
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        })
      : '';
    const rows = isiAnggaran.map((row, index) => ({
      nomor: index + 1,
      akun: row?.akun ?? '',
      subakun: row?.subakun ?? '',
      nominalPengajuan: formatRibu(row?.nom_pro ?? 0),
      nominalApproval: formatRibu(row?.nom_app ?? 0),
    }));
    const html = buildProposalExcelHtml({
      title: `PROPOSAL ANGGARAN CABANG ${String(namaCabang).toUpperCase()} BULAN ${String(namaBulan).toUpperCase()} ${tahun}`,
      subtitle: `Status Proposal: ${statusLabel}${statusDate ? `, Tgl. ${statusDate}` : ''}`,
      rows,
    });
    const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = [
      'Proposal_Anggaran',
      sanitizeExcelFilePart(namaCabang),
      sanitizeExcelFilePart(namaBulan),
      sanitizeExcelFilePart(tahun),
    ].join('_') + '.xls';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  return (
    <div className="container-fluid">
  
  <div className="row">
        
          <label className="fs-4 text fw-bold">Proposal Anggaran</label>
          <div className="flex-grow h-px bg-gray-300 mb-3"></div>
          <div className = 'row mb-3'>
               {/** INFO PERIODE */}
                <div className = 'col-md-2'>
                  <label>Cabang</label>
                  <select
                    className="form-control border-danger"
                    value={cabang ?? ""}
                    onChange={(e) => {
                      setCabang(e.target.value);}}>
                    {(!kodeCabangUser || isPusat) 
                      ? <option key={''} value={''}>-Pilih Cabang-</option> 
                      : null}
                    {(!kodeCabangUser || isPusat) 
                      ? opsiCabang.map(x => (x.kode_cabang === 'C-1' ? null : <option key={x.kode_cabang} value={x.kode_cabang}>{x.nama_cabang}</option>))
                      : <option key={kodeCabangUser} value={kodeCabangUser}>{namaCabangUser}</option>}
                  </select>
                </div>
                <div className = 'col-md-2'>
                  <label>Bulan Anggaran</label>
                  <select
                    className="form-control border-danger"
                    value={bulan ?? ''}
                    onChange={(e) => {
                      if(!cabang || cabang === ''){showNotif("error","Pilih Cabang terlebih dahulu"); return};
                      setBulan(e.target.value);
                      }}>
                    <option value={''}>-Pilih Periode-</option>
                    {opsiBulan.map(x => <option key={x} value={x}>{formatBulan(x)}</option>)}
                  </select>
                </div>
                <div className = 'col-md-1'>
                  <label>Tahun</label>
                  <select
                    className="form-control border-danger"
                    value={tahun ?? ''}
                    onChange={(e) => {
                      setTahun(e.target.value);}}>
                    <option value={tahunNow}>{tahunNow}</option>
                    {opsiTahun.map(x => (x === tahunNow ? null : <option key = {x} value={x}>{x}</option>))}
                  </select>
                </div>
                <div className = 'col-md-1 text-center'>
                  <label>Status</label>
                  <input
                      disabled
                      style={status === 'APPR' ? {color : "#084b00", background : "#cbe5c8"}
                              : status === 'SENT' ? {color : "#000156", background : "#c8c8e5"} 
                              : {color : "#560000", background : "#e5c8c8"}}
                      className="form-control fw-bold text-center"
                      value={status}
                    />
                </div>
                <div className='row col-md-6 text-center'>
                    <div className='col-md-3  text-center'>
                      <label>Total Proposal</label>
                      <input
                          disabled
                          className="form-control text-center"
                          
                          value={formatRibu(totalPro ?? 0) }
                        />
                    </div>
                    <div className='col-md-3 text-center'>
                      <label>Tanggal Pengajuan</label>
                      <input
                          disabled
                          className="form-control text-center"
                          value={status ? formatWIB(dataAnggaran?.tgl_pro) ?? '' : '---'}
                        />
                    </div>
                    <div className='col-md-3  text-center'>
                      <label>Total Approval</label>
                      <input
                          disabled
                          className="form-control text-center fw-bold"
                          style={{backgroundColor : '#c1e4d0'}}
                          value={formatRibu(totalApp ?? 0) }
                        />
                    </div>
                    <div className='col-md-3 text-center'>
                      <label>Tanggal Approval</label>
                      <input
                          disabled
                          className="form-control text-center"
                          style={{backgroundColor : '#c1e4d0'}}
                          value={status === 'APPR' ? formatWIB(dataAnggaran?.tgl_app) ?? '' : '---'}
                        />
                    </div>  
                </div>     
                
          </div>  
          <div className='row col-md-12 text-start mt-4 mb-2'>
                        
                        <button
                            type = "button"
                            className="btn border-primary btn-outline-primary mx-1 col-md-1"
                            onClick={async()=>{
                            if(bulan === '') {
                              //batal
                              showNotif('error', 'Belum Pilih Periode'); return;
                            } 
                            console.log("status =", status);
                            if(isPusat && status === 'DRAFT') {
                              //batal
                              showNotif('error', 'Tidak bisa edit DRAFT'); 
                              return}
                            if(isPusat && status === 'SENT') {
                              //kembali ke draft
                              showConfirm({
                                title: 'Kembalikan Proposal',
                                message: 'Yakin ingin mengembalikan proposal untuk revisi?',
                                onConfirm: () => {
                                  const isiAngg = isiAnggaran.map(row => {return {...row, nom_app : 0}});
                                  setIsiAnggaran(isiAngg);
                                  handleSubmitProposal('DRAFT', isiAngg);
                                }
                              });
                              return;}
                            if(isPusat && status === 'APPR') {
                              //kembali ke sent
                              showConfirm({
                                title: 'Batalkan Approval',
                                message: 'Yakin ingin membatalkan approval?',
                                onConfirm: () => {
                                  handleSubmitProposal('SENT');
                                }
                              });
                              return;}
                            if(!isPusat && status === 'DRAFT') {
                              //update draft
                              //console.log("update draft = ", isiAnggaran);
                              handleSubmitProposal("DRAFT");
                              showNotif('success', 'Draft berhasil diperbaharui.');
                              return;}
                            if(!isPusat && status === 'SENT') {
                              //batal
                              showNotif('error', 'Tidak bisa edit data');
                              return;}    
                            if(!isPusat && status === 'APPR') {
                              //batal
                              showNotif('error', 'Tidak bisa edit data');
                              return;}    
                            }}>
                              {isPusat 
                              ? <><i className="fa fa-solid fa-rotate-left"/> UNDO</>
                              : <><i className="fa fa-solid fa-save"/> DRAFT</>
                            }
                        </button>
                        <button
                            type = "button"
                            className="btn border-primary btn-primary mx-1 col-md-1"
                            onClick={()=>{
                              if(bulan === '') {showNotif('error', 'Belum Pilih Periode')}
                              if(isPusat && status === 'DRAFT') {
                                //batal
                                showNotif('error', 'Tidak bisa save edit data');
                                return;}
                              if(isPusat && status === 'SENT') {
                                //Approved
                                showConfirm({
                                title: 'Berikan Approval',
                                message: 'Approve proposal. Lanjutkan?',
                                onConfirm: () => {
                                  handleSubmitProposal('APPR');
                                }
                              });
                                return;}
                              if(isPusat && status === 'APPR') {
                                //batal
                                showNotif('error', 'Tidak bisa save edit data');
                                return;}
                              if(!isPusat && status === 'DRAFT') {
                                //kirim ke Pusat
                                showConfirm({
                                title: 'Kirim Proposal',
                                message: 'Proposal akan dikirim. Lanjutkan?',
                                onConfirm: () => {
                                  handleSubmitProposal('SENT');
                                }
                              });
                                return;}
                              if(!isPusat && status === 'SENT') {
                                //batal
                                showNotif('error', 'Tidak bisa save edit data');
                                return;}
                              if(!isPusat && status === 'APPR') {
                                //batal
                                showNotif('error', 'Tidak bisa save edit data');
                                return;}          
                              }}
                            >
                              {isPusat 
                              ? <>APPROVE</>
                              : <>KIRIM  <i className="fa fa-solid fa-forward text-white"/></> 
                              }
                        </button>
          </div>

        <div className="flex-grow h-px bg-gray-300 my-3"></div>
         
      {/** TABEL */}
      <div className="col-md-8">
          <div className="card">
            <div className="warna-table-header card-header d-flex justify-content-between align-items-center" 
            style={{ fontWeight:"bold"}}>
            Daftar Mata Anggaran
            <button className="btn ls" style={{fontSize: "large", color: "#fff"}} 
              onClick={()=>{
                }}></button>
            </div>

            <div className="card-body p-0">
              <div className="row my-2 mx-1 ">
                <div className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
                    {/** FILTER */}
                    <div className="row col-md-4">
                      <div className="row col-md-6 mx-2">
                        <select
                          className="form-control"
                          value={filter ?? ''}
                          onChange={(e) => {setFilter(e.target.value);}}>
                          <option value={''}>-All-</option>
                          {uniqueAkun.map(x => <option key={x} value={x}>{x}</option>)}
                        </select>
                      </div>
                      <div className="row col-md-6">
                          <input
                            className="form-control"
                            placeholder={`Cari..`}
                            value={search ?? ''}
                            onChange={e => {
                              setSearch(e.target.value);
                            }}
                          />
                      </div>
                    </div>

                    <div className="ms-auto text-end">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleDownloadProposal}
                      >
                        <i className="fa fa-solid fa-download text-white me-2"/>
                        Download Proposal
                      </button>
                    </div>

                    {/** BUTTON UPLOAD DOWNLOAD*/          
                    !isPusat && false &&
                    <div className="row col-md-2">
                      <div className='col-md-6 text-end'>
                          <button
                              type = "button"
                              className="btn border-primary btn-primary pr-2 col-md-10"
                              onClick={async ()=>{
                                if(bulan === '') {showNotif('error', 'Tidak ada data'); return;} 
                                showConfirm({
                                title: 'Download Form Proposal',
                                message: 'Form kosong untuk input laporan melalui Excel. Lanjutkan?',
                                onConfirm: async () => {
                                  await ExcelDown("tabelProposal", `Proposal-${opsiCabang.find(x => x.kode_cabang === cabang).nama_cabang}-${bulan}-${tahun}`);  
                                  showNotif('success', 'File Excel berhasil di download');
                                }});  
                              }}
                              ><i className="fa fa-solid fa-download text-white"/>
                          </button>
                      </div>
                      <div className='col-md-6 text-start'> 
                          <button
                              type = "button"
                              className="btn border btn-danger col-md-10"
                              onClick={()=>{if(bulan === '') {showNotif('error', 'Belum Pilih Periode')} else {
                                showConfirm({
                                title: 'Upload File .xlsx atau .xls',
                                message: 'Data upload akan menimpa exsisting data. Lanjutkan?',
                                onConfirm: ()=>{
                                  if(isPusat || status !== 'DRAFT')
                                    { 
                                      showNotif('error','Proposal terkirim tidak bisa diedit');
                                      return;
                                    };
                                  handleUpload();
                                },
                                }); 
                              }}}
                              ><i className="fa fa-solid fa-upload text-white"/>
                          </button>
                      </div>
                    </div>
                    }
                </div>
              </div>

              {/** KONTEN TABEL */}
              <table className="table table-bordered table-hover" id="tabelProposal">
                <thead>
                  <tr>
                    <th>
                      <div className="text-center">
                        <span>No.</span>
                      </div>
                    </th>
                    <th>
                      <div className="text-center">
                        <span>Akun</span>
                      </div>
                    </th>

                    <th>
                      <div className="text-center">
                        <span>Sub Akun</span>
                      </div>
                    </th>

                    <th>
                      <div className="text-center">
                        <span>Nominal Pengajuan</span>
                      </div>
                    </th> 

                    <th>
                      <div className="d-flex justify-content-between align-items-center text-center">
                        <div className='btn btn-outline-primary ' style={{cursor : "pointer"}} onClick={()=>{handlecopy();}} ><i className='fa-solid fa-arrow-right'/></div>
                        <div>
                        Nominal Approval</div>
                        </div>
                        <div></div>
                    </th>
                  </tr>
                </thead>
                <tbody> 
                    { !filteredData || filteredData?.length === 0 || (!(dataAnggaran?.isi?.length > 0) && isPusat)
                        ? <tr>
                          <td></td>
                          <td><div className='my-10'>Tidak Ada Data</div></td>
                          </tr>
                        : filteredData.map((row,i) => (
                      <tr key={`${i+row.subakun}`}>
                        <td className='text-end'>{i+1}</td>
                        <td className=''>{row.akun}</td>
                        <td className=''>{row.subakun}</td>
                        <td className='text-center'>
                          <input
                          disabled = {isPusat ? true : false }
                          className='text-end' 
                          type='text'
                          inputMode="numeric"
                          value={formatRibu(row.nom_pro ?? 0)}
                          onChange={(e) => {
                            const input = e.target.value.replace(/[^\d]/g, '');
                            setIsiAnggaran(prev =>
                                  prev.map(item => {
                                    if (
                                      trimTxt(`${item.akun}-${item.subakun}`) ===
                                      trimTxt(`${row.akun}-${row.subakun}`)
                                    ) {
                                      return {
                                        ...item,
                                        nom_pro: Number(input)
                                      };
                                    }
                                    return item;
                                  })
                                );}}
                          />
                          </td>
                          
                        <td className='text-end'>
                          <input
                          disabled = {isPusat ? false : true }
                          className='text-end' 
                          type='text'
                          inputMode="numeric"
                          value={formatRibu(row.nom_app ?? 0)}
                          onChange={(e) => {
                            const input = e.target.value.replace(/[^\d]/g, '');
                            setIsiAnggaran(prev =>
                                  prev.map(item => {
                                    if (
                                      trimTxt(`${item.akun}-${item.subakun}`) ===
                                      trimTxt(`${row.akun}-${row.subakun}`)
                                    ) {
                                      return {
                                        ...item,
                                        nom_app: Number(input)
                                      };
                                    }
                                    return item;
                                  })
                                );}}
                          /></td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/* PAGINATION NAV */}
            <div className="d-flex justify-content-between align-items-center my-2 mx-3">
          </div>
          </div>
      </div>
        
  </div>
      </div>
  );
}
